{
  "it": {
    "headlines": {
      "admin": {
        "dashboard": {
          "title": "Pannello di controllo",
          "modelsByClassification": "Modelli per classificazione",
          "models": "Modelli ricaricati",
          "modelsByManufacturer": "Modelli per produttore",
          "manufacturers": "Produttori",
          "modelsByStatus": "Modelli per stato",
          "modelsBySize": "Modelli per dimensione",
          "modelsPerMonth": "Modelli al mese",
          "componentsByClass": "Componenti per classe",
          "components": "Componenti",
          "visitsPerDay": "Visite al giorno",
          "visitsPerMonth": "Visite al mese",
          "mostViewedPages": "Pagine più visitate",
          "registrationsPerMonth": "Registrazioni al mese",
          "users": "Utenti"
        },
        "models": {
          "index": "Modelli",
          "edit": {
            "index": "Modifica modello",
            "fleetchart": "Immagini grafico flotta",
            "positions": "Posizioni dell'equipaggio",
            "hardpoints": "Punti di montaggio",
            "cargoAndFuel": "Carburante",
            "cargoHolds": "Stive di carico",
            "metrics": "Metriche",
            "prices": "Prezzi",
            "docks": "Dock",
            "modules": "Moduli",
            "paints": "Verniciature",
            "videos": "Video",
            "images": "Immagini",
            "itemPrices": "Prezzi degli articoli",
            "linkModule": "Collega modulo esistente",
            "loaners": "Prestiti",
            "snubCrafts": "Snub Craft",
            "upgrades": "Upgrade",
            "packages": "Pacchetti",
            "linkUpgrade": "Collega upgrade esistente",
            "history": "Cronologia"
          },
          "new": "Nuovo modello",
          "show": "Modello",
          "images": "Immagini",
          "tableConfigurationModal": "Configurazione tabella"
        },
        "components": {
          "index": "Componenti",
          "new": "Nuovo componente",
          "edit": {
            "index": "Modifica componente",
            "itemPrices": "Prezzi degli articoli",
            "history": "Cronologia"
          }
        },
        "modelPaints": {
          "index": "Verniciature",
          "new": "Nuova verniciatura",
          "edit": "Modifica verniciatura",
          "copy": "Copia verniciatura su nave",
          "bulkCopy": "Copia %{count} verniciature su nave"
        },
        "modelModules": {
          "index": "Moduli",
          "new": "Nuovo modulo",
          "edit": "Modifica modulo",
          "models": "Modelli collegati",
          "prices": "Prezzi",
          "hardpoints": "Punti di montaggio",
          "cargoHolds": "Stive di carico",
          "history": "Cronologia"
        },
        "unlistedModels": {
          "index": "Navi nei file di gioco senza modello",
          "link": "Collega a una nave del catalogo"
        },
        "manufacturers": {
          "index": "Produttori",
          "new": "Nuovo produttore",
          "edit": "Modifica produttore"
        },
        "supporterContributions": {
          "index": "Contributi dei sostenitori",
          "new": "Nuovo contributo",
          "edit": "Modifica contributo",
          "perMonth": "Contributi al mese"
        },
        "fundingGoals": {
          "index": "Obiettivi di finanziamento",
          "new": "Nuovo obiettivo di finanziamento",
          "edit": "Modifica obiettivo di finanziamento"
        },
        "users": {
          "index": "Utenti",
          "edit": "Modifica utente",
          "fleets": "Flotte",
          "inventories": "Inventari"
        },
        "vehicles": {
          "index": "Veicoli",
          "edit": "Modifica veicolo"
        },
        "fleets": {
          "index": "Flotte",
          "edit": "Modifica flotta",
          "members": "Membri",
          "memberEdit": "Modifica membro",
          "history": "Cronologia",
          "roles": "Ruoli",
          "inventories": "Inventari",
          "inventoryItems": "Voci"
        },
        "destroyedFleets": {
          "index": "Flotte eliminate"
        },
        "admins": {
          "index": "Amministratori",
          "new": "Nuovo amministratore",
          "edit": "Modifica amministratore"
        },
        "oauthApplications": {
          "index": "Applicazioni OAuth",
          "new": "Nuova applicazione OAuth",
          "edit": "Modifica applicazione OAuth"
        },
        "features": {
          "index": "Flag funzionalità",
          "show": "Dettagli funzionalità",
          "globalState": "Stato globale",
          "groups": "Gruppi",
          "actors": "Attori",
          "selfService": "Self-service",
          "percentageOfActors": "Percentuale degli attori",
          "percentageOfTime": "Percentuale di tempo",
          "addActor": "Aggiungi attore"
        },
        "rsiApiStatus": {
          "index": "Stato API RSI"
        },
        "images": {
          "index": "Immagini"
        },
        "imports": {
          "index": "Importazioni"
        },
        "notifications": {
          "index": "Notifiche"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "Test Visivi",
          "notifications": "Notifiche"
        }
      },
      "welcome": "Benvenuto su",
      "welcomeShips": "Ultime Navi",
      "welcomeImages": "Immagini Casuali",
      "ships": {
        "index": "Indice Delle Navi",
        "fleetchart": "Grafico flotta navi"
      },
      "images": "Indice Delle Immagini",
      "stats": "Statistiche",
      "notFound": "Errore di Navigazione",
      "forbidden": "Accesso negato",
      "featureNotReady": "In arrivo",
      "accessDenied": "Accesso negato",
      "serverError": "Errore del server",
      "comments": "Commenti",
      "login": "Accedi",
      "hangar": {
        "index": "Il Mio Hangar",
        "preview": {
          "h1": "Anteprima del Mio Hangar",
          "h2": "Il tuo Hangar personale richiede un account FleetYards.net",
          "h3": "Quali caratteristiche include l'Hangar?"
        },
        "alternativeNames": "Nomi alternativi",
        "stats": "Statistiche",
        "public": "Hangar di %{user}",
        "import": "Importa",
        "wishlist": "Lista dei desideri",
        "publicStats": "Statistiche",
        "publicWishlist": "Lista dei desideri di %{user}",
        "resetIngame": "Resetta le navi in gioco dopo il wipe"
      },
      "syncExtension": "Sincronizza hangar RSI",
      "editMyVehicle": "Modifica il mio %{vehicle}",
      "nameMyVehicle": "Dai un nome al mio %{vehicle}",
      "editGroups": "Modifica i Gruppi",
      "newVehicles": "Aggiungi Navi",
      "myVehicleAddons": "Aggiungi Moduli / Upgrades per %{vehicle}",
      "myVehicleLoadouts": "Loadouts per %{vehicle}",
      "addToHangar": "Aggiungi \"%{model}\" al tuo Hangar",
      "impressum": "Info legali",
      "privacy": "Informativa sulla privacy",
      "cookie": "Informativa sui Cookie",
      "requestPassword": "Richiedi la password",
      "changePassword": "Cambia la password",
      "confirmAccess": "Conferma l'accesso",
      "setEmail": "Imposta il tuo indirizzo email",
      "oauthAuthorize": "Autorizza applicazione",
      "filterModels": "Filtra Le Navi",
      "filterVehicles": "Filtra Hangar",
      "fleets": {
        "owners": "Proprietari",
        "add": "Crea una nuova flotta",
        "invites": "Inviti Alla Flotta",
        "inviteUrls": "URL d'invito",
        "members": {
          "index": "Members",
          "worldmap": "Mappa mondiale dei membri",
          "starmap": "Mappa stellare dei membri"
        },
        "stats": "Statistiche",
        "preview": {
          "h1": "Anteprima della Flotta",
          "h2": "Per creare una flotta devi avere un account su FleetYards.net",
          "h3": "Quali caratteristiche include la tua flotta?"
        },
        "settings": {
          "fleet": "Impostazioni Della Flotta",
          "membership": "Impostazioni dei Membri",
          "roles": "Ruoli flotta",
          "notifications": "Impostazioni Notifiche",
          "inAppNotifications": "Notifiche in-app",
          "discord": "Discord",
          "calendar": "Calendario",
          "features": "Funzionalità della flotta"
        },
        "inviteMember": "Invita nuovo membro",
        "calendarSubscription": "Abbonamento al calendario",
        "missions": {
          "index": "Missioni",
          "create": "Crea missione",
          "edit": "Modifica missione",
          "editBasic": "Dettagli di base",
          "editDescription": "Descrizione e copertina",
          "editTeams": "Team e slot",
          "teams": "Team",
          "ships": "Navi",
          "slots": "Slot",
          "addTeam": "Aggiungi team",
          "editTeam": "Modifica team",
          "addShip": "Aggiungi nave",
          "editShip": "Modifica nave"
        },
        "events": {
          "index": "Eventi",
          "calendar": "Calendario",
          "create": "Crea evento",
          "edit": "Modifica evento",
          "editBasic": "Dettagli di base",
          "editDescription": "Descrizione e copertina",
          "editTeams": "Team e slot",
          "spawn": "Genera evento",
          "details": "Dettagli evento",
          "schedule": "Programmazione",
          "settings": "Impostazioni",
          "lifecycle": "Ciclo di vita",
          "signupTitle": "Iscrivimi",
          "yourSignup": "La tua iscrizione",
          "spawnedFrom": "Generato da questa missione",
          "pickTemplate": "Scegli un modello di missione",
          "unassignedSignups": "Iscrizioni non assegnate",
          "eventTeam": "Team dell'evento",
          "grantRole": "Assegna un ruolo",
          "editTeam": "Modifica team",
          "addTeam": "Aggiungi team",
          "editShip": "Modifica nave",
          "addShip": "Aggiungi nave",
          "assignSlotFor": "Assegna slot a %{username}",
          "reassignSlotFor": "Riassegna slot a %{username}"
        }
      },
      "hangarGroup": {
        "create": "Crea Gruppo",
        "edit": "Modifica Gruppo"
      },
      "compare": {
        "ships": "Confronta Navi"
      },
      "settings": {
        "account": "Profilo",
        "profile": "Impostazioni del Profilo",
        "hangar": "Impostazioni dell'Hangar",
        "privacy": "Impostazioni Privacy",
        "features": "Flag funzionalità",
        "connections": "Connessioni",
        "oauthApplications": "Applicazioni OAuth",
        "notifications": "Impostazioni Notifiche",
        "verify": "Verifica il tuo account RSI",
        "security": {
          "index": "Sicurezza dell'account",
          "twoFactor": "Autenticazione a due fattori"
        },
        "twoFactor": {
          "enable": "Attiva Autenticazione A Due Fattori",
          "disable": "Disattiva Autenticazione A Due Fattori",
          "backupCodes": "Genera Codici Di Backup Autenticazione a Due Fattori"
        },
        "calendar": "Abbonamento al calendario"
      },
      "oauthApplications": {
        "new": "Nuova applicazione OAuth",
        "edit": "Modifica applicazione OAuth"
      },
      "roadmap": "Roadmap Delle Navi",
      "tools": {
        "index": "Strumenti",
        "travelTimes": "Tempi di viaggio",
        "cargoGrids": "Griglie di carico",
        "profitCalculator": {
          "index": "Calcolatore Dei Profitti"
        },
        "tradeRoutes": {
          "index": "Rotte Commerciali",
          "withShip": "Rotte Commerciali per %{name} (%{cargo})"
        }
      },
      "rsiVerification": "Verifica il tuo account RSI",
      "hangarGuideEmpty": "Non c'è molto da vedere qui?",
      "hangarGuide": "Guida all'Hangar",
      "support": "Supporta FleetYards.net",
      "supporters": "Grazie ai nostri sostenitori",
      "supportHint": {
        "hangarSync": "Felici di averti aiutato con la sincronizzazione",
        "vehicleAdded": "Il tuo hangar sta crescendo",
        "fleetCreated": "Una nuova flotta — ottimo!",
        "loginMilestone": "Grazie per essere ancora qui",
        "visitMilestone": "Ti piace FleetYards?"
      },
      "vehicle": {
        "bulkGroupEdit": "Aggiungi/rimuovi Gruppi"
      },
      "pagination": {
        "count": "%{current} di %{total}"
      },
      "models": {
        "index": "Modelli"
      },
      "modals": {
        "models": {
          "displayOptions": "Opzioni di visualizzazione"
        },
        "shopCommodity": {
          "update": "Aggiorna Merce %{shopCommodity}",
          "create": "Aggiungi Merce",
          "sellPrices": "Prezzi di vendita di %{shopCommodity}",
          "buyPrices": "Prezzi di Acquisto %{shopCommodity}",
          "rentalPrices": "Prezzi di Noleggio %{shopCommodity}"
        },
        "commodityPrice": {
          "create": "Invia Prezzo"
        }
      },
      "visualTests": {
        "overview": "Panoramica",
        "panels": "Pannelli",
        "buttons": "Pulsanti",
        "media": "Media",
        "charts": "Grafici",
        "chips": "Chips Test Visivi",
        "events": "Eventi",
        "typography": "Tipografia",
        "forms": "Moduli",
        "tables": "Tabelle",
        "lists": "Elenchi",
        "metrics": "Metriche",
        "states": "Stati",
        "notifications": "Notifiche",
        "syncModal": "Modal sincronizzazione",
        "overlays": "Overlay",
        "supportHint": "Suggerimento supporto",
        "notificationCenter": "Centro notifiche"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item"
      },
      "notifications": {
        "index": "Notifiche"
      },
      "filterCargoRoutes": "Filtra rotte di carico",
      "filterCommodities": "Filtra Merci",
      "starsystems": "Sistemi Stellari",
      "starsystem": "Sistema Stellare %{starsystem}",
      "celestialObjects": "Oggetto Celeste",
      "celestialObject": "%{celestialObject} nel Sistema di %{starsystem}",
      "moons": "Lune",
      "stations": "Stazioni Spaziali",
      "station": "%{station} vicino a %{celestialObject}",
      "stationImages": "Immagini di %{station} vicino a %{celestialObject}",
      "shops": "Negozi",
      "shop": "%{shop} su %{station}",
      "commodities": "Merci"
    }
  }
}
